import { Navigate } from "react-router-dom";
import DashboardCrm from "../pages/DashboardCrm";
import Login from "../pages/Authentication/Login";
import Role from "pages/Role";
import AddRole from "pages/Role/RoleForm";
import VerifyEmailPage from "../pages/Authentication/VerifyEmail";
import ForgotPasswordPage from "pages/Authentication/ForgotPassword";
import Staff from "pages/Staff";
import AddStaff from "pages/Staff/StaffForm";
import Customer from "pages/Customer";
import AddCustomer from "pages/Customer/CustomerForm";
import Material from "pages/Master/Material/Material";
import Indentation from "pages/PurchaseOrder/Indentation";
import PurchaseOrder from "pages/PurchaseOrder/PurchaseOrder";
import AddIndentation from "pages/PurchaseOrder/Indentation/AddIndentation";
import MaterialGroup from "pages/Master/MaterialGroup/MaterialGroup";
import ManuFacturer from "pages/Master/ManuFacturer/ManuFacturer";
import Project from "pages/Project/Project";
import ChangePassword from "pages/Profile/ChangePassword";
import Profile from "pages/Profile/Profile";
import Product from "pages/Product";
import ProductForm from "pages/Product/ProductForm";
import AddPurchaseOrder from "pages/PurchaseOrder/PurchaseOrder/AddPurchaseOrder";
import ReceivedOrder from "pages/PurchaseOrder/PurchaseOrder/ReceivedPurchaseOrder";
import AddGRN from "pages/PurchaseOrder/PurchaseOrder/AddGRN";
import Vendor from "pages/Master/Vendor";
import AddVendor from "pages/Master/Vendor/VendorForm";
import Technician from "pages/Master/Technician";
import AddTechnician from "pages/Master/Technician/TechnicianForm";
import Order from "pages/Order";
import AddOrder from "pages/Order/AddOrder";
import AddOrderPayment from "pages/Order/AddPayment";
import ViewOrder from "pages/Order/ViewOrder";
import { moduleName } from "Components/constants/Common";
import JobCardPage from "pages/JobCard";
import JobForm from "pages/JobCard/jobform";
import OrderReport from "pages/reports/orderReport";
import PurchaseOrderReport from "pages/reports/POReport";
import JobCardReport from "pages/reports/JobCardReport";
import AddPurchaseOrderPayment from "pages/PurchaseOrder/PurchaseOrder/AddPayment";
import ViewPurchaseOrder from "pages/PurchaseOrder/PurchaseOrder/ViewHistory";
import Store from "pages/Master/Store";
import AddStore from "pages/Master/Store/StoreForm";
import EmailComposePage from "pages/email-template";
import { components } from "react-select";
import mail from "pages/Mail/mail";
import Mail from "pages/Mail/mail";
import EmailComposePagePO from "pages/email-template-po";
import EmailComposePageGRN from "pages/email-template-grn";
import Services from "pages/Services/Services";
import HsnSacPage from "pages/HSN-SAC/HsnSacPage";
import RepairOrderOpening from "pages/OrderService/RepairOrderOpening";
import ROOform from "pages/OrderService/ROOform";
import RepairOrdClosing from "pages/OrderService/RepairOrdClosing";
import RepairOrdReopen from "pages/OrderService/RepairOrdReopen";
import PartsIssueDetails from "pages/OrderService/PartsIssueDetails";
import Quotation from "pages/SalesOrder/Quotation";
import QuotationForm from "pages/SalesOrder/Quotation/QuotationForm";
import WorkOrder from "pages/SalesOrder/WorkOrder";
import WorkOrderForm from "pages/SalesOrder/WorkOrder/WorkOrderForm";
import ProformaInvoice from "pages/SalesOrder/ProformaInvoice";
import ProformaInvoiceForm from "pages/SalesOrder/ProformaInvoice/ProformaInvoiceForm";
import PartRequisition from "pages/PurchaseOrder/Indentation/PartRequisition";
import CreditNote from "pages/SalesOrder/CreditNote";
import CreditNoteForm from "pages/SalesOrder/CreditNote/CreditNoteForm";
import TaxInvoice from "pages/SalesOrder/TaxInvoice";
import TaxInvoiceForm from "pages/SalesOrder/TaxInvoice/TaxInvoiceForm";
import RoPurchaseOrder from "pages/RoPurchaseOrder";
import RoPOForm from "pages/RoPurchaseOrder/RoPOForm";
import ROReturnIndex from "pages/RetunRoNPo/ROReturnIndex";
import POReturnIndex from "pages/RetunRoNPo/POReturnIndex";
import POReturnForm from "pages/RetunRoNPo/POReturnForm";
import ROReturnForm from "pages/RetunRoNPo/ROReturnForm";
import ROReturnHistory from "pages/RetunRoNPo/ROReturnHistory";
import POReturnHistory from "pages/RetunRoNPo/POReturnHistory";
import PartIssueTable from "pages/OrderService/PartIssueTable";
import PartIssueHistory from "pages/OrderService/PartIssueHistory";

const authProtectedRoutes = [
  {
    path: "/dashboard",
    component: <DashboardCrm />,
    module_name: moduleName.Public,
  },
  { path: "/role", component: <Role />, module_name: moduleName.Configuration },
  {
    path: "/addrole",
    component: <AddRole />,
    module_name: moduleName.Configuration,
  },
  {
    path: "/editrole/:id",
    component: <AddRole />,
    module_name: moduleName.Configuration,
  },
  { path: "/staff", component: <Staff />, module_name: moduleName.Staff },
  { path: "/addstaff", component: <AddStaff />, module_name: moduleName.Staff },
  {
    path: "/editstaff/:id",
    component: <AddStaff />,
    module_name: moduleName.Staff,
  },
  {
    path: "/services",
    component: <Services />,
    module_name: moduleName.Service,
  },
  {
    path: "/hsn_sac",
    component: <HsnSacPage />,
    module_name: moduleName.HsnSac,
  },
  {
    path: "/customer",
    component: <Customer />,
    module_name: moduleName.Customers,
  },
  {
    path: "/addcustomer",
    component: <AddCustomer />,
    module_name: moduleName.Customers,
  },
  {
    path: "/editcustomer/:id",
    component: <AddCustomer />,
    module_name: moduleName.Customers,
  },
  {
    path: "/material",
    component: <Material />,
    module_name: moduleName.Material,
  },
  {
    path: "/material-group",
    component: <MaterialGroup />,
    module_name: moduleName.MaterialGroup,
  },
  {
    path: "/make",
    component: <ManuFacturer />,
    module_name: moduleName.Make,
  },
  { path: "/project", component: <Project />, module_name: moduleName.Project },
  {
    path: "/change-password",
    component: <ChangePassword />,
    module_name: moduleName.ChangePassword,
  },
  {
    path: "/profile",
    component: <Profile />,
    module_name: moduleName.Profile,
  },
  { path: "/product", component: <Product />, module_name: moduleName.Product },
  {
    path: "/addproduct",
    component: <ProductForm />,
    module_name: moduleName.Product,
  },
  {
    path: "/editproduct/:id/:varientId",
    component: <ProductForm />,
    module_name: moduleName.Product,
  },
  {
    path: "/indentation",
    component: <Indentation />,
    module_name: moduleName.Generation,
  },
  {
    path: "/add-indentation",
    component: <AddIndentation />,
    module_name: moduleName.Generation,
  },
  {
    path: "/edit-indentation/:id",
    component: <AddIndentation />,
    module_name: moduleName.Generation,
  },
  {
    path: "/purchase-order",
    component: <PurchaseOrder />,
    module_name: moduleName.Received,
  },
  {
    path: "/add-purchase-order/:id",
    component: <AddPurchaseOrder />,
    module_name: moduleName.Received,
  },
  {
    path: "/edit-purchase-order/:editId",
    component: <AddPurchaseOrder />,
    module_name: moduleName.Received,
  },
  {
    path: "/add-payment-purchase-order/:id",
    component: <AddPurchaseOrderPayment />,
    module_name: moduleName.Received,
  },
  {
    path: "/view-purchase-order-history/:id",
    component: <ViewPurchaseOrder />,
    module_name: moduleName.Received,
  },
  // {
  //   path: "/received-purchase-order/:id",
  //   component: <ReceivedOrder />,
  //   module_name: moduleName.Received,
  // },
  // {
  //   path: "/edit-received-purchase-order/:editId",
  //   component: <ReceivedOrder />,
  //   module_name: moduleName.Received,
  // },
  {
    path: "/add-grn/:id",
    component: <AddGRN />,
    module_name: moduleName.Received,
  },
  {
    path: "/add-ro-grn/:id",
    component: <AddGRN />,
    module_name: moduleName.Received,
  },
  {
    path: "/edit-grn/:editId",
    component: <AddGRN />,
    module_name: moduleName.Received,
  },
  { path: "/vendor", component: <Vendor />, module_name: moduleName.Vendor },
  {
    path: "/addvendor",
    component: <AddVendor />,
    module_name: moduleName.Vendor,
  },
  {
    path: "/editvendor/:id",
    component: <AddVendor />,
    module_name: moduleName.Vendor,
  },
  {
    path: "/technician",
    component: <Technician />,
    module_name: moduleName.Technician,
  },
  {
    path: "/add-technician",
    component: <AddTechnician />,
    module_name: moduleName.Technician,
  },
  {
    path: "/edit-technician/:id",
    component: <AddTechnician />,
    module_name: moduleName.Technician,
  },
  { path: "/order", component: <Order />, module_name: moduleName.Orders },
  {
    path: "/add-order",
    component: <AddOrder />,
    module_name: moduleName.Orders,
  },
  {
    path: "/add-order-payment/:id",
    component: <AddOrderPayment />,
    module_name: moduleName.Orders,
  },
  {
    path: "/view-order/:id",
    component: <ViewOrder />,
    module_name: moduleName.Orders,
  },
  {
    path: "/return-order/:id",
    component: <AddOrder />,
    module_name: moduleName.Orders,
  },
  {
    path: "/order-report",
    component: <OrderReport />,
    module_name: moduleName.Reports,
  },
  {
    path: "/purchase-order-report",
    component: <PurchaseOrderReport />,
    module_name: moduleName.Reports,
  },
  {
    path: "/job-card-report",
    component: <JobCardReport />,
    module_name: moduleName.Reports,
  },
  {
    path: "/job-card",
    component: <JobCardPage />,
    module_name: moduleName.JobCard,
  },
  { path: "/add-job", component: <JobForm />, module_name: moduleName.JobCard },
  {
    path: "/job-form/:jobId",
    component: <JobForm />,
    module_name: moduleName.JobCard,
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
    module_name: moduleName.Dashboard,
  },
  {
    path: "*",
    component: <Navigate to="/dashboard" />,
    module_name: moduleName.Dashboard,
  },
  {
    path: "/store",
    component: <Store />,
    module_name: moduleName.Store,
  },
  {
    path: "/add-store",
    component: <AddStore />,
    module_name: moduleName.Store,
  },
  {
    path: "/edit-store/:id",
    component: <AddStore />,
    module_name: moduleName.Store,
  },
  {
    path: "/compose/:id",
    component: <EmailComposePage />,
    module_name: moduleName.Orders,
  },
  {
    path: "/composepo/:id",
    component: <EmailComposePagePO />,
    module_name: moduleName.Received,
  },
  {
    path: "/compose-grn-invoice/:id/:version",
    component: <EmailComposePageGRN />,
    module_name: moduleName.Received,
  },
  {
    path: "/repairOrder",
    component: <RepairOrderOpening />,
    module_name: moduleName.RepairOrderOpening,
  },
  {
    path: "/addRepairOrder",
    component: <ROOform />,
    module_name: moduleName.RepairOrderOpening,
  },
  {
    path: "/editRepairOrder/:id",
    component: <ROOform />,
    module_name: moduleName.RepairOrderOpening,
  },
  {
    path: "/partIssueDetails",
    component: <PartIssueTable />,
    module_name: moduleName.PartsIssueDetaiils,
  },
  {
    path: "/partIssueDetailsForm",
    component: <PartsIssueDetails />,
    module_name: moduleName.PartsIssueDetaiils,
  },
  {
    path: "/editPartIssueDetailsForm/:id",
    component: <PartsIssueDetails />,
    module_name: moduleName.PartsIssueDetaiils,
  },
  {
    path: "/viewPartIssueDetailsForm/:id",
    component: <PartsIssueDetails />,
    module_name: moduleName.PartsIssueDetaiils,
  },
  {
    path: "/partIssueHistory/:id",
    component: <PartIssueHistory />,
    module_name: moduleName.PartsIssueDetaiils,
  },
  {
    path: "/repairOrderClosing",
    component: <RepairOrdClosing />,
    module_name: moduleName.RepairOrderClosing,
  },
  {
    path: "/repairOrderReOpen",
    component: <RepairOrdReopen />,
    module_name: moduleName.RepairOrderReopen,
  },

  {
    path: "/quotation",
    component: <Quotation />,
    module_name: moduleName.Quotation,
  },
  {
    path: "/add-quotation",
    component: <QuotationForm />,
    module_name: moduleName.Quotation,
  },
  {
    path: "/edit-quotation/:quotationId",
    component: <QuotationForm />,
    module_name: moduleName.Quotation,
  },
  {
    path: "/view-quotation/:quotationId",
    component: <QuotationForm />,
    module_name: moduleName.Quotation,
  },
  {
    path: "/work-order",
    component: <WorkOrder />,
    module_name: moduleName.WorkOrder,
  },
  {
    path: "/add-work-order",
    component: <WorkOrderForm />,
    module_name: moduleName.WorkOrder,
  },
  {
    path: "/edit-work-order/:workOrderId",
    component: <WorkOrderForm />,
    module_name: moduleName.WorkOrder,
  },
  {
    path: "/view-work-order/:workOrderId",
    component: <WorkOrderForm />,
    module_name: moduleName.WorkOrder,
  },
  {
    path: "/proforma-invoice",
    component: <ProformaInvoice />,
    module_name: moduleName.ProformaInvoice,
  },
  {
    path: "/proforma-invoice",
    component: <ProformaInvoice />,
    module_name: moduleName.ProformaInvoice,
  },
  {
    path: "/add-proforma-invoice",
    component: <ProformaInvoiceForm />,
    module_name: moduleName.ProformaInvoice,
  },
  {
    path: "/edit-proforma-invoice/:proformaId",
    component: <ProformaInvoiceForm />,
    module_name: moduleName.ProformaInvoice,
  },
  {
    path: "/partRequisition",
    component: <Indentation />,
    module_name: moduleName.RepairOrderOpening,
  },
  {
    path: "/add-partRequisition",
    component: <PartRequisition />,
    module_name: moduleName.RepairOrderOpening,
  },
  {
    path: "/edit-partRequisition/:id",
    component: <PartRequisition />,
    module_name: moduleName.RepairOrderOpening,
  },
  {
    path: "/partRequisitionWORo",
    component: <PartRequisition />,
    module_name: moduleName.Generation,
  },
  {
    path: "/editPartRequisitionWORo/:id",
    component: <PartRequisition />,
    module_name: moduleName.Generation,
  },
  {
    path: "/addPurchaseOrder/:prid",
    component: <RoPOForm />,
    module_name: moduleName.Generation,
  },
  {
    path: "/editPurchaseOrder/:poid",
    component: <RoPOForm />,
    module_name: moduleName.Generation,
  },
  {
    path: "/viewPurchaseOrder/:poid",
    component: <RoPOForm />,
    module_name: moduleName.PurchaseOrder,
  },
  {
    path: "/RoPurchaseOrder",
    component: <RoPurchaseOrder />,
    module_name: moduleName.PurchaseOrder,
  },
  {
    path: "/addRoPurchaseOrder",
    component: <RoPOForm />,
    module_name: moduleName.PurchaseOrder,
  },
  {
    path: "/editRoPurchaseOrder/:id",
    component: <RoPOForm />,
    module_name: moduleName.PurchaseOrder,
  },
  {
    path: "/viewRoPurchaseOrder/:id",
    component: <RoPOForm />,
    module_name: moduleName.PurchaseOrder,
  },
  {
    path: "/POReturn",
    component: <POReturnIndex />,
    module_name: moduleName.ReturnPurchaseOrder,
  },
  {
    path: "/addPOReturn",
    component: <POReturnForm />,
    module_name: moduleName.ReturnPurchaseOrder,
  },
  {
    path: "/editPOReturn/:id",
    component: <POReturnForm />,
    module_name: moduleName.ReturnPurchaseOrder,
  },
  {
    path: "/viewPOReturn/:id",
    component: <POReturnForm />,
    module_name: moduleName.ReturnPurchaseOrder,
  },
  {
    path: "/addROReturn",
    component: <ROReturnForm />,
    module_name: moduleName.ReturnRepairOrder,
  },
  {
    path: "/editROReturn/:id",
    component: <ROReturnForm />,
    module_name: moduleName.ReturnRepairOrder,
  },
  {
    path: "/viewROReturn/:id",
    component: <ROReturnForm />,
    module_name: moduleName.ReturnRepairOrder,
  },
  {
    path: "/ROReturnHistory/:id",
    component: <ROReturnHistory />,
    module_name: moduleName.ReturnRepairOrder,
  },
  {
    path: "/POReturnHistory/:id",
    component: <POReturnHistory />,
    module_name: moduleName.ReturnPurchaseOrder,
  },
  {
    path: "/ROReturn",
    component: <ROReturnIndex />,
    module_name: moduleName.ReturnRepairOrder,
  },
  {
    path: "/credit-note",
    component: <CreditNote />,
    module_name: moduleName.CreditNote,
  },
  {
    path: "/add-credit-note",
    component: <CreditNoteForm />,
    module_name: moduleName.CreditNote,
  },
  {
    path: "/edit-credit-note/:creditNoteId",
    component: <CreditNoteForm />,
    module_name: moduleName.CreditNote,
  },
  {
    path: "/tax-invoice",
    component: <TaxInvoice />,
    module_name: moduleName.TaxInvoice,
  },
  {
    path: "/add-tax-invoice",
    component: <TaxInvoiceForm />,
    module_name: moduleName.TaxInvoice,
  },
  {
    path: "/edit-tax-invoice/:taxInvoiceId",
    component: <TaxInvoiceForm />,
    module_name: moduleName.TaxInvoice,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login />, module_name: moduleName.Public },
  {
    path: "/verify-email",
    component: <VerifyEmailPage />,
    module_name: moduleName.Public,
  },
  {
    path: "/forget-password",
    component: <ForgotPasswordPage />,
    module_name: moduleName.Public,
  },
];

export { authProtectedRoutes, publicRoutes };
